// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_option = require("rescript/lib/js/js_option.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Log$SmartcutsMacros = require("../../bs-macros-extension/src/Log.bs.js");
var ArrayUtils$SmartcutsMacros = require("./ArrayUtils.bs.js");
var Exceptions$SmartcutsMacros = require("../../bs-macros-extension/src/Exceptions.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("./JsPromiseErrorUtils.bs.js");

function map(promise, f) {
  return promise.then(function (x) {
              return Promise.resolve(Curry._1(f, x));
            });
}

function map2(f, promise) {
  return promise.then(function (x) {
              return Promise.resolve(Curry._1(f, x));
            });
}

function resolveWith(f, promise) {
  return map(promise, f);
}

function rejectWith(message) {
  return Promise.reject(new (global.Error)(message));
}

function cancelTimeout(delay, message) {
  return new Promise((function (param, reject) {
                setTimeout((function (param) {
                        return reject(new (global.Error)(message));
                      }), delay);
                
              }));
}

function toString(obj) {
  return Js_option.getExn(JSON.stringify(obj));
}

function getOrReject(opt) {
  if (opt !== undefined) {
    return Promise.resolve(Caml_option.valFromOption(opt));
  } else {
    return Promise.reject(new (global.Error)("Unable to get"));
  }
}

function rejectIfEmpty(error, results) {
  if (results.length !== 0) {
    return Promise.resolve(results);
  } else {
    return Promise.reject(new (global.Error)(error));
  }
}

function pickFirst(results) {
  return Promise.resolve(Caml_array.get(results, 0));
}

function append_result(results, prom) {
  return prom.then(function (result) {
              return Promise.resolve([result].concat(results));
            });
}

function append_result2(prom, results) {
  return append_result(results, prom);
}

function doAll(promiseList) {
  return promiseList.reduce((function (accPromise, thisPromise) {
                return accPromise.then(function (results) {
                            return append_result(results, thisPromise);
                          });
              }), Promise.resolve([]));
}

function doAllWithProgressUpdate(onProgressUpdate, promises) {
  var nResolved = {
    contents: 0
  };
  return Promise.all(Belt_Array.map(promises, (function (param) {
                    return map(param, (function (result) {
                                  nResolved.contents = nResolved.contents + 1 | 0;
                                  Curry._1(onProgressUpdate, nResolved.contents);
                                  return result;
                                }));
                  })));
}

function sequentiallyWithIndex(fn, xs) {
  return $$Array.fold_left((function (promise, param) {
                var x = param[1];
                var index = param[0];
                return promise.then(function (results) {
                            return append_result(results, Curry._2(fn, index, x));
                          });
              }), Promise.resolve([]), $$Array.mapi((function (index, x) {
                    return [
                            index,
                            x
                          ];
                  }), xs));
}

function sequentiallyWithIndex2(xs, fn) {
  return Belt_Array.reduceWithIndex(xs, Promise.resolve([]), (function (promise, x, index) {
                return promise.then(function (results) {
                            return append_result(results, Curry._2(fn, index, x));
                          });
              }));
}

function sequentially(fn, xs) {
  return sequentiallyWithIndex((function (_index, x) {
                return Curry._1(fn, x);
              }), xs);
}

function sequentially2(xs, fn) {
  return sequentiallyWithIndex2(xs, (function (_index, x) {
                return Curry._1(fn, x);
              }));
}

function sequentiallyEvalResults(f, xs) {
  var match = ArrayUtils$SmartcutsMacros.splitAtFirst(xs);
  if (match === undefined) {
    return Promise.resolve({
                TAG: /* Ok */0,
                _0: []
              });
  }
  var partial_arg = [];
  return Belt_Array.reduceWithIndex(match[1], Curry._1(f, match[0]).then(function (param) {
                  if (param.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: [param._0]
                          };
                  } else {
                    return {
                            TAG: /* Error */1,
                            _0: {
                              returns: partial_arg,
                              error: param._0,
                              remaining: xs
                            }
                          };
                  }
                }), (function (promise, x, index) {
                return promise.then(function (result) {
                            if (result.TAG !== /* Ok */0) {
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: result._0
                                        });
                            }
                            var returns = result._0;
                            return Curry._1(f, x).then(function (result) {
                                        if (result.TAG === /* Ok */0) {
                                          return Promise.resolve({
                                                      TAG: /* Ok */0,
                                                      _0: Belt_Array.concat(returns, [result._0])
                                                    });
                                        } else {
                                          return Promise.resolve({
                                                      TAG: /* Error */1,
                                                      _0: {
                                                        returns: returns,
                                                        error: result._0,
                                                        remaining: Belt_Array.sliceToEnd(xs, index)
                                                      }
                                                    });
                                        }
                                      });
                          });
              }));
}

function doAllFns(fns) {
  return $$Array.fold_left((function (promise, fn) {
                return promise.then(function (results) {
                            return append_result(results, Curry._1(fn, undefined));
                          });
              }), Promise.resolve([]), fns);
}

function sequentiallyList(fn, lst) {
  return Belt_List.reduce(lst, Promise.resolve(undefined), (function (resolved, item) {
                return resolved.then(function (param) {
                            return Curry._1(fn, item);
                          });
              }));
}

function wrapInTimeout(milliseconds, makePromise) {
  return new Promise((function (resolve, param) {
                setTimeout((function (param) {
                        Curry._1(makePromise, undefined).then(function (x) {
                              resolve(x);
                              return Promise.resolve(undefined);
                            });
                        
                      }), milliseconds);
                
              }));
}

function shortcutWithIndexAndState(init, f, xs) {
  return Belt_Array.reduceWithIndex(xs, Promise.resolve([
                    init,
                    undefined
                  ]), (function (promise, x, index) {
                  return promise.then(function (result) {
                              if (result[1] !== undefined) {
                                return Promise.resolve(result);
                              } else {
                                return Curry._3(f, result[0], x, index);
                              }
                            });
                })).then(function (param) {
              return Promise.resolve(param[1]);
            });
}

function shortcutWithState(init, f, xs) {
  return shortcutWithIndexAndState(init, (function (state, x, _index) {
                return Curry._2(f, state, x);
              }), xs);
}

function shortcutWithIndex(f, xs) {
  return shortcutWithIndexAndState(undefined, (function (unit, x, index) {
                return Curry._2(f, x, index).then(function (output) {
                            return Promise.resolve([
                                        unit,
                                        output
                                      ]);
                          });
              }), xs);
}

function shortcut(f, xs) {
  return shortcutWithIndexAndState(undefined, (function (unit, x, _index) {
                return Curry._1(f, x).then(function (output) {
                            return Promise.resolve([
                                        unit,
                                        output
                                      ]);
                          });
              }), xs);
}

function orPromise(promiseA, promiseB) {
  return Promise.all([
                promiseA,
                promiseB
              ]).then(function (param) {
              return Promise.resolve(param[0] || param[1]);
            });
}

function makeCancelable(makePromise) {
  var isCanceled = {
    contents: false
  };
  var cancelCallbacks = {
    contents: []
  };
  var addCancelCallback = function (callback) {
    if (isCanceled.contents) {
      return Curry._1(callback, undefined);
    } else {
      cancelCallbacks.contents = $$Array.append(cancelCallbacks.contents, [callback]);
      return ;
    }
  };
  var cancelPromise = function (param) {
    isCanceled.contents = true;
    return Belt_Array.forEach(cancelCallbacks.contents, (function (callback) {
                  return Curry._1(callback, undefined);
                }));
  };
  var doPromise = function (param) {
    if (isCanceled.contents) {
      throw {
            RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
            Error: new Error()
          };
    }
    return Curry._2(makePromise, addCancelCallback, isCanceled).then(function (res) {
                if (isCanceled.contents) {
                  throw {
                        RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                        Error: new Error()
                      };
                }
                return Promise.resolve(res);
              });
  };
  return [
          doPromise,
          cancelPromise
        ];
}

function makePromiseCancelableBySurroundingPromise(addCancelCallback, promiseBuilder) {
  var match = makeCancelable(function (addCancelCallback, isCanceled) {
        if (isCanceled.contents) {
          throw {
                RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                Error: new Error()
              };
        }
        return Curry._1(promiseBuilder, addCancelCallback);
      });
  Curry._1(addCancelCallback, match[1]);
  return Curry._1(match[0], undefined);
}

function withRetriesInner(retries, didCancelRetries, doPromise, shouldRetryForJsPromiseError, $$default) {
  if (Curry._1(didCancelRetries, undefined)) {
    if ($$default !== undefined) {
      return Promise.resolve(Caml_option.valFromOption($$default));
    }
    throw {
          RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
          Error: new Error()
        };
  }
  var promise = Curry._1(doPromise, undefined).then(function (result) {
        if (!Curry._1(didCancelRetries, undefined)) {
          return Promise.resolve(result);
        }
        if ($$default !== undefined) {
          return Promise.resolve(Caml_option.valFromOption($$default));
        }
        throw {
              RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
              Error: new Error()
            };
      });
  if (Curry._1(didCancelRetries, undefined) || retries === 1) {
    if (retries === 1) {
      Curry._1(Log$SmartcutsMacros.promiseRetries.log1, "Last retry");
    } else if (Curry._1(didCancelRetries, undefined)) {
      Curry._1(Log$SmartcutsMacros.promiseCancels.log1, "Retries were canceled");
    }
    return promise.catch(function (jsPromiseError) {
                if (Curry._1(shouldRetryForJsPromiseError, jsPromiseError)) {
                  if ($$default !== undefined) {
                    return Promise.resolve(Caml_option.valFromOption($$default));
                  }
                  if (Curry._1(didCancelRetries, undefined)) {
                    throw {
                          RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled,
                          Error: new Error()
                        };
                  }
                  return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
                }
                var match = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                if (match === 1) {
                  
                } else {
                  console.warn("ERROR", jsPromiseError);
                }
                return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
              });
  } else {
    return promise.catch(function (jsPromiseError) {
                var waitMilliseconds = Math.imul(100, Math.pow(2, (3 - retries | 0) + 1 | 0) | 0);
                if (Curry._1(shouldRetryForJsPromiseError, jsPromiseError)) {
                  return new Promise((function (resolve, param) {
                                setTimeout((function (param) {
                                        withRetriesInner(retries - 1 | 0, didCancelRetries, doPromise, shouldRetryForJsPromiseError, $$default).then(function (res) {
                                              resolve(res);
                                              return Promise.resolve(undefined);
                                            });
                                        
                                      }), waitMilliseconds);
                                
                              }));
                }
                var match = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.getErrorType, jsPromiseError);
                if (match === 1) {
                  
                } else {
                  console.warn("ERROR", jsPromiseError);
                }
                return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
              });
  }
}

function withRetries(retries, doPromise, shouldRetryForJsPromiseError, $$default, param) {
  var didCallerCancelRetries = {
    contents: false
  };
  var cancelCallbacks = {
    contents: []
  };
  var addCancelCallback = function (callback) {
    if (didCallerCancelRetries.contents) {
      return Curry._1(callback, undefined);
    } else {
      cancelCallbacks.contents = $$Array.append(cancelCallbacks.contents, [callback]);
      return ;
    }
  };
  var cancelRetries = function (param) {
    didCallerCancelRetries.contents = true;
    return Belt_Array.forEach(cancelCallbacks.contents, (function (callback) {
                  return Curry._1(callback, undefined);
                }));
  };
  var doPromise$1 = function (param) {
    return withRetriesInner(retries, (function (param) {
                  return didCallerCancelRetries.contents;
                }), Curry._1(doPromise, addCancelCallback), shouldRetryForJsPromiseError, $$default);
  };
  return [
          doPromise$1,
          cancelRetries
        ];
}

function untilNoMatchingJsPromiseError(waitMillisecondsBeforeNextAttemptOpt, doPromise, doesErrorMatch, param) {
  var waitMillisecondsBeforeNextAttempt = waitMillisecondsBeforeNextAttemptOpt !== undefined ? waitMillisecondsBeforeNextAttemptOpt : 200;
  return Curry._1(doPromise, undefined).catch(function (jsPromiseError) {
              if (Curry._1(doesErrorMatch, jsPromiseError)) {
                return new Promise((function (resolve, param) {
                              setTimeout((function (param) {
                                      untilNoMatchingJsPromiseError(waitMillisecondsBeforeNextAttempt, doPromise, doesErrorMatch, undefined).then(function (result) {
                                            resolve(result);
                                            return Promise.resolve(undefined);
                                          });
                                      
                                    }), waitMillisecondsBeforeNextAttempt);
                              
                            }));
              } else {
                return Promise.reject(Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.toExn, jsPromiseError));
              }
            });
}

function withTimeout(timeout, promise) {
  return new Promise((function (resolve_, param) {
                setTimeout((function (param) {
                        promise.then(function (result) {
                              resolve_(result);
                              return Promise.resolve(undefined);
                            });
                        
                      }), timeout);
                
              }));
}

function retryAll(retries, makePromise, shouldRetryForJsPromiseError, $$default, xs) {
  var didCallerCancelRetries = {
    contents: false
  };
  var cancelCallbacks = {
    contents: []
  };
  var addCancelCallback = function (callback) {
    if (didCallerCancelRetries.contents) {
      return Curry._1(callback, undefined);
    } else {
      cancelCallbacks.contents = $$Array.append(cancelCallbacks.contents, [callback]);
      return ;
    }
  };
  var cancelRetries = function (param) {
    didCallerCancelRetries.contents = true;
    return Belt_Array.forEach(cancelCallbacks.contents, (function (callback) {
                  return Curry._1(callback, undefined);
                }));
  };
  var doPromise = function (param) {
    return Belt_Array.reduce(xs, Promise.resolve([]), (function (prevPromise, x) {
                  return prevPromise.then(function (prevResults) {
                              return map(withRetriesInner(retries, (function (param) {
                                                return didCallerCancelRetries.contents;
                                              }), (function (param) {
                                                return Curry._2(makePromise, addCancelCallback, x);
                                              }), shouldRetryForJsPromiseError, $$default), (function (result) {
                                            return Belt_Array.concat(prevResults, [result]);
                                          }));
                            });
                }));
  };
  return [
          doPromise,
          cancelRetries
        ];
}

function mapResult2(result, mapOk, mapError) {
  if (result.TAG === /* Ok */0) {
    return Curry._1(mapOk, result._0);
  } else {
    return Promise.resolve({
                TAG: /* Error */1,
                _0: Curry._1(mapError, result._0)
              });
  }
}

function mapResult(result, f) {
  return mapResult2(result, f, (function (x) {
                return x;
              }));
}

function mapOption(maybeValue, f, resolveNoneAs) {
  if (maybeValue !== undefined) {
    return Curry._1(f, Caml_option.valFromOption(maybeValue));
  } else {
    return Promise.resolve(resolveNoneAs);
  }
}

function withTimer(timerName, resolver, promise) {
  var performance$1 = performance;
  var t0 = performance$1.now();
  return promise.then(Curry.__1(resolver)).then(function (result) {
              var t1 = performance$1.now();
              console.log(timerName, t1 - t0);
              return Promise.resolve(result);
            });
}

exports.map = map;
exports.map2 = map2;
exports.resolveWith = resolveWith;
exports.rejectWith = rejectWith;
exports.cancelTimeout = cancelTimeout;
exports.toString = toString;
exports.getOrReject = getOrReject;
exports.rejectIfEmpty = rejectIfEmpty;
exports.pickFirst = pickFirst;
exports.append_result = append_result;
exports.append_result2 = append_result2;
exports.doAll = doAll;
exports.doAllWithProgressUpdate = doAllWithProgressUpdate;
exports.sequentiallyWithIndex = sequentiallyWithIndex;
exports.sequentiallyWithIndex2 = sequentiallyWithIndex2;
exports.sequentially = sequentially;
exports.sequentially2 = sequentially2;
exports.sequentiallyEvalResults = sequentiallyEvalResults;
exports.doAllFns = doAllFns;
exports.sequentiallyList = sequentiallyList;
exports.wrapInTimeout = wrapInTimeout;
exports.shortcutWithIndexAndState = shortcutWithIndexAndState;
exports.shortcutWithState = shortcutWithState;
exports.shortcutWithIndex = shortcutWithIndex;
exports.shortcut = shortcut;
exports.orPromise = orPromise;
exports.makeCancelable = makeCancelable;
exports.makePromiseCancelableBySurroundingPromise = makePromiseCancelableBySurroundingPromise;
exports.withRetries = withRetries;
exports.untilNoMatchingJsPromiseError = untilNoMatchingJsPromiseError;
exports.withTimeout = withTimeout;
exports.retryAll = retryAll;
exports.mapResult2 = mapResult2;
exports.mapResult = mapResult;
exports.mapOption = mapOption;
exports.withTimer = withTimer;
/* Log-SmartcutsMacros Not a pure module */
